import { useTranslation } from 'libs/i18n'
import { ContextMenu } from 'shared/components'
import { Detail } from 'shared/atoms'
import type { Option } from 'shared/components/ContextMenu/types'
import type { AreaTypeItem } from '../../types/areaTypes.types'

export type AreaTypeProps = {
	boothType: AreaTypeItem
	menuOptions: Option[]
}

export const AreaType = ({ boothType, menuOptions }: AreaTypeProps) => {
	const { t } = useTranslation()

	return (
		<li className="p-4">
			<div className="flex items-start justify-between gap-3">
				<p className="min-w-0 text-[13px] font-semibold text-foreground">{boothType.name}</p>
				<ContextMenu
					dataId={boothType.id}
					item={boothType}
					options={menuOptions}
					label={t('Actions for {{ name }}', { name: boothType.name })}
				/>
			</div>
			<dl className="mt-2 grid grid-cols-2 gap-x-4 gap-y-2 text-[11px]">
				<Detail
					className="col-span-2"
					label={t('Description')}
					value={boothType.description || '—'}
				/>
			</dl>
		</li>
	)
}
